import { DASHBOARD_STATUSES, type DashboardStatus } from '../../constants/business/dashboard';

/**
 * By default:
 *
 * Green: value <= steps[0]
 *
 * Orange: steps[0] < value <= steps[1]
 *
 * Red: steps[1] < value
 *
 * If options.startFromRed = true then
 *
 * Red: value <= steps[0]
 *
 * Orange: steps[0] < value <= steps[1]
 *
 * Green: steps[1] < value
 **/
export function getDashboardStatusBySteps(
    value: number | null,
    steps: readonly [number, number],
    options?: { startFromRed?: boolean },
) {
    if (value === null) {
        return null;
    }

    if (value <= steps[0]) {
        return options?.startFromRed ? DASHBOARD_STATUSES.RED : DASHBOARD_STATUSES.GREEN;
    }

    if (steps[0] < value && value <= steps[1]) {
        return DASHBOARD_STATUSES.ORANGE;
    }

    return options?.startFromRed ? DASHBOARD_STATUSES.GREEN : DASHBOARD_STATUSES.RED;
}

export function getDashboardHighestStatus(statuses: (DashboardStatus | null)[]) {
    if (statuses.includes(DASHBOARD_STATUSES.RED)) {
        return DASHBOARD_STATUSES.RED;
    }

    if (statuses.includes(DASHBOARD_STATUSES.ORANGE)) {
        return DASHBOARD_STATUSES.ORANGE;
    }

    return DASHBOARD_STATUSES.GREEN;
}
